'use strict';

/**
 * Builds the marquee by cloning the content until it reaches a length of two times the container width.
 * @param {jQuery} $wrapper - The wrapper element containing the marquee.
 * @param {jQuery} $container - The container element which the marquee is inside.
 * @param {jQuery} $marqueeContent - The element containing the marquee content.
 * @returns {undefined}
 */
function buildMarquee($wrapper, $container, $marqueeContent) {
    $wrapper.find('.marquee-content').not(':first').remove();
    let totalWidth = $marqueeContent.outerWidth(true);
    const targetWidth = $container.outerWidth(true) * 2;

    while (totalWidth < targetWidth) {
        const $clone = $marqueeContent.clone();
        $wrapper.append($clone);
        totalWidth += $clone.outerWidth(true);
    }

    $wrapper.css({
        animation: 'marquee 20s linear infinite',
        animationPlayState: 'running'
    });

    // Manual hover pause/resume
    $('.marquee-box').hover(
        function () {
            $wrapper.css('animation-play-state', 'paused');
        },
        function () {
            $wrapper.css('animation-play-state', 'running');
        }
    );

    $wrapper.addClass('initialized');
}

/**
 * Initializes the marquee by waiting for images to load and then invoking the build function.
 *
 * @function
 * @private
 * @returns {undefined}
 */
function initializeMarquee() {
    const $wrapper = $('.marquee-wrapper');
    const $container = $('.features');
    const $marqueeContent = $('.marquee-content').first();
    if (!$wrapper.length || $wrapper.hasClass('initialized') || !$marqueeContent.length) return;

    const $images = $marqueeContent.find('img');
    let loadedCount = 0;

    $images.each(function () {
        if (this.complete) {
            loadedCount += 1;
        } else {
            $(this).on('load error', function () {
                loadedCount += 1;
                if (loadedCount === $images.length) {
                    buildMarquee($wrapper, $container, $marqueeContent);
                }
            });
        }
    });

    if (loadedCount === $images.length) {
        buildMarquee($wrapper, $container, $marqueeContent);
    }
}

$(document).ready(function () {
    initializeMarquee();
});

$('body').on('initMarqueeContent', function () {
    initializeMarquee();
});
